import { fetchStageVideos } from './ajax.js';
import { stageVideoStore } from './store.js';
import { loadTemplate } from '../../template/index.js';
import { handleClick } from './handlers.js';
import { displayList, triggerStageVideosReload } from './render.js';

let stageContainer = null;
let currentStageId = null;

/**
 * Initialize stage videos
 */
export async function initStageVideos() {
	stageContainer = document.querySelector('.stage-videos');
	if (!stageContainer) return;

	currentStageId = stageContainer.getAttribute('data-stage-id');
	if (!currentStageId) return;

	stageVideoStore.setStageId(currentStageId);

	// Listen for reload event
	document.addEventListener('stage-videos-reload', reloadStageVideos);

	// Event delegation for delete buttons
	stageContainer.addEventListener('click', handleClick);

	await loadAndDisplay();
}

/**
 * Load templates and videos, then display
 */
async function loadAndDisplay() {
	if (!stageContainer || !currentStageId) return;

	const [videos] = await Promise.all([
		fetchStageVideos(currentStageId),
		loadTemplate('stage/video/item.ejs'),
		loadTemplate('stage/video/empty.ejs'),
		loadTemplate('stage/video/list-title.ejs'),
	]);

	stageVideoStore.setVideos(videos);
	displayList(stageContainer);
}

/**
 * Reload videos and re-render
 */
async function reloadStageVideos() {
	if (!currentStageId) return;

	const videos = await fetchStageVideos(currentStageId);
	stageVideoStore.setVideos(videos);
	displayList(stageContainer);
}

export { triggerStageVideosReload };
